import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { AzureBlobFSLinkedService } from './azure-blob-fs.linkedservice';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.sapDatasphereForAzureDataLakeStorageGen2LinkedService,
    display: [
        format(
            shellStringResources.ModelName_LinkedServiceTemplate,
            shellStringResources.SapDatasphereForAzureDataLakeStorageGen2LinkedService_DisplayText
        ),
        format(
            shellStringResources.ModelName_LinkedServicesTemplate,
            shellStringResources.SapDatasphereForAzureDataLakeStorageGen2LinkedService_DisplayText
        )
    ]
})
export class SapDatasphereForAzureDataLakeStorageGen2LinkedService extends AzureBlobFSLinkedService {
    public static readonly MODEL: IModel;
}
